// Import Core
import React, { useEffect } from "react";
import styled from "styled-components";
// Import Libraries
import { Link } from "@reach/router";
// Import Components
import Button from "../../ui/buttons/Button";
import useRequestsAfter3Dcheck from "../../../hooks/useRequestsAfter3Dcheck";

const FormConfirmationStyling = styled.section`
  display: flex;
  flex-direction: column;
  .content-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 120px;
    gap: 96px;
    @media (max-width: 992px) {
      padding: 40px 64px;
      gap: 40px;
    }
    @media (max-width: 768px) {
      padding: 40px 24px;
      flex-direction: column;
      flex-direction: column-reverse;
    }
    .section-title {
      width: 50%;
      max-width: 519px;
      padding: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 24px;
      @media (max-width: 768px) {
        width: 100%;
        gap: 16px;
      }
      .content {
        p:not(:first-child) {
          margin-top: 16px;
        }
        .brochure-links {
          a {
            text-decoration: underline;
            &:not(:first-child) {
              margin-left: 8px;
            }
          }
        }
      }
      .btn-group {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        gap: 24px;
        @media (max-width: 768px) {
          flex-direction: column;
          gap: 16px;
        }
      }
    }
  }
`;

const FormConfirmation = ({ queryParams }) => {
  const sendRequests = useRequestsAfter3Dcheck();
  // Get parameters from url query string
  const formType = queryParams.get("type");
  const status = queryParams.get("status");
  const brochures = queryParams.get("brochures");

  useEffect(() => {
    if (status === "success") {
      sendRequests();
    }
  }, []);

  console.log(status, "status");

  let subtitle = "";
  let title = "";
  let content = "";

  const renderBrochureContent = () => {
    if (status == "success") {
      return (
        <>
          <p>
            If you have ordered brochures by post, the team will send them to
            you directly as soon as possible.
          </p>
          {brochures?.length && (
            <p>
              In the meantime, here are the brochures you requested, available
              for download in PDF format.
            </p>
          )}
          <p className="brochure-links">
            {brochures?.includes("short-breaks-2026") && (
              <a
                href="https://umi360-largefs.s3.us-east-1.amazonaws.com/kirker/Kirker_Short_Breaks_2026.pdf"
                target="_blank"
              >
                Short Breaks 2026
              </a>
            )}
            {brochures?.includes("cultural-tours-2026") && (
              <a
                href="https://umi360-largefs.s3.us-east-1.amazonaws.com/kirker/Kirker_Cultural_Tours_and_Music_Holidays_2026.pdf"
                target="_blank"
              >
                Cultural Tours 2026
              </a>
            )}
            {brochures?.includes("cultural-tours-2027") && (
              <a
                href="https://umi360-largefs.s3.us-east-1.amazonaws.com/kirker/CTMH_2027.pdf"
                target="_blank"
              >
                Cultural Tours 2027
              </a>
            )}
            {brochures?.includes("italy-tours-2026") && (
              <a
                href="https://umi360-largefs.s3.us-east-1.amazonaws.com/kirker/Italy_2026-2027.pdf"
                target="_blank"
              >
                Italy 2026-27
              </a>
            )}
            {brochures?.includes("spain-portugal-tours-2025") && (
              <a
                href="https://umi360-largefs.s3.us-east-1.amazonaws.com/kirker/Spain_and_Portugal_2025-2026.pdf"
                target="_blank"
              >
                Spain Portugal 2025-26
              </a>
            )}
            {brochures?.includes("france-tours-2026") && (
              <a
                href="https://umi360-largefs.s3.us-east-1.amazonaws.com/kirker/Kirker_France_2026.pdf"
                target="_blank"
              >
                France 2026
              </a>
            )}
          </p>
          <p>
            Best regards,
            <br />
            The Kirker Team
          </p>
        </>
      );
    } else {
      return "There has been an error. If the problem persists, please contact us directly";
    }
  };

  if (formType === "enquiry") {
    subtitle = status === "success" ? "Thank you" : "Error";
    title =
      // status === 'success' ? 'Thank you for your enquiry' : 'We are sorry';
      status === "success" ? "Thank you" : "We are sorry";
    content =
      status === "success"
        ? "One of our team will be in touch with you shortly"
        : "There has been an error. If the problem persists, please contact us directly";
  } else if (formType === "newsletter") {
    subtitle = status === "success" ? "Newsletter Signup" : "Error";
    title = status === "success" ? "Thank you" : "We are sorry";
    content =
      status === "success"
        ? "Thank you for signing up to our newsletter."
        : "There has been an error. If the problem persists, please contact us directly";
  } else if (formType === "brochure") {
    subtitle =
      status === "success"
        ? "Thank you for requesting brochures from Kirker holidays."
        : "Error";
    title = status == "success" ? "Thank you" : "We are sorry";
    content = renderBrochureContent();
  }

  // enquiry-form
  // brochure-form
  // newsletter-form

  return (
    <FormConfirmationStyling>
      <div className="content-wrapper">
        <div className="section-title">
          {/* <p className='tagline'>{subtitle}</p> */}
          <h1>{title}</h1>
          <div className="content">{content}</div>

          <div className="btn-group">
            <Link to="/">
              <Button
                size="md"
                btnStyle="default"
                value="Home"
                clickHandler={true}
                isDisabled={false}
              />
            </Link>

            <Link to="/make-an-enquiry">
              <Button
                size="md"
                btnStyle="outline"
                value="Contact"
                clickHandler={false}
                isDisabled={false}
              />
            </Link>
          </div>
        </div>
        {/* <SectionTitle
          className='section-title'
          subtitle={subtitle}
          title={title}
          content={content}

          button={
            <Link to='/'>
              <Button>
                Home
              </Button>
            </Link>
          }
          buttonTwo={
            <Link to='/contact-us'>
              <Button className='primary-outline-btn button-two'>
                Contact
              </Button>
            </Link>
          }
        /> */}
      </div>
    </FormConfirmationStyling>
  );
};
export default FormConfirmation;
